import {Calculator} from './components/Calculator'
import {Header} from './components/Header'
import {CalculatorProvider} from './contexts/CalculatorContext'
import {useAuth} from '@/contexts/AuthContext'
import {Login} from '@/pages/Login'

function App() {
    const {user, loading} = useAuth()

    if (loading) {
        return <div>Loading...</div>
    }

    if (!user) {
        return <Login />
    }

    return (
        <CalculatorProvider>
            <div className="min-h-screen bg-background">
                <Header/>
                <main className="container mx-auto px-4 py-6">
                    <Calculator/>
                </main>
            </div>
        </CalculatorProvider>
    )
}

export default App